import React, { useEffect, useState } from "react";
import {
  addSettings,
  updateSettings,
  DeleteSettings,
  listSettings,
} from "../../../src/components/Dashboard/api/Api";
import EmojiPicker from "emoji-picker-react";

import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import "bootstrap/dist/css/bootstrap.min.css";

const specialChars = ["@", "#", "$", "%", "&", "*", "(", ")", "{", "}", "[", "]", "₹", "€", "£", "!", "?", "<", ">", "=", "+", "-", "/", "\\", "“"];

const insertSpecialCharacter = (textareaName, char, setFormData, formData) => {
  const textarea = document.querySelector(`textarea[name='${textareaName}']`);
  if (!textarea) return;
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  const newValue =
    (formData[textareaName] || "").substring(0, start) +
    char +
    (formData[textareaName] || "").substring(end);

  setFormData((prev) => ({ ...prev, [textareaName]: newValue }));
  textarea.focus();
  textarea.selectionStart = textarea.selectionEnd = start + char.length;
};
// ======================================================
//  View Message Modal
// ======================================================
const ViewMessageModal = ({ show, onClose, message, title }) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-light">
            <h5 className="modal-title fw-semibold">
              {title ? `Message: ${title}` : "Full Message"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              style={{
                background: 'transparent url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\' fill=\'%23000\'%3e%3cpath d=\'m.235 1.027 1.027-.235 6.738 6.738 6.738-6.738 1.027.235-6.738 6.738 6.738 6.738-1.027.235-6.738-6.738-6.738 6.738-1.027-.235 6.738-6.738z\'/%3e%3c/svg%3e") center/1em auto no-repeat',
                border: 'none',
                fontSize: '1rem',
                opacity: 0.5,
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => e.target.style.opacity = '1'}
              onMouseLeave={(e) => e.target.style.opacity = '0.5'}
            ></button>
          </div>
          <div className="modal-body">
            <div
              className="p-3 border rounded bg-light"
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                lineHeight: "1.6"
              }}
            >
              {message || "No message content available."}
            </div>
          </div>
          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ======================================================
// ✨ Edit Notification Modal
// ======================================================
const EditNotificationModal = ({ show, onClose, notification, onSave }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (notification) {
      // Ensure consistent field mapping and include the ID
      const mappedNotification = {
        id: notification.id || notification._id,
        pageName: notification.pagename || notification.pageName || notification.page || "",
        pageType: notification.type || notification.pageType || "marquee",
        direction: notification.direction || "left",
        title: notification.title || "",
        message: notification.message || notification.notification || "",
        cookieTime: notification.cookie_time || notification.cookieTime || 24,
        validity: notification.validity ? notification.validity.split("T")[0] : "",
      };
      setFormData(mappedNotification);
    }
  }, [notification]);

  if (!show) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.pageName || !formData.message) {
      alert("Please fill in all required fields (Page Name and Message)");
      return;
    }
    
    // console.log("Form data being submitted:", formData); // Debug log
    onSave(formData);
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content border-0 shadow-sm">
          <div className="modal-header bg-light">
            <h5 className="modal-title fw-semibold">Edit Notification</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              style={{
                background: 'transparent url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\' fill=\'%23000\'%3e%3cpath d=\'m.235 1.027 1.027-.235 6.738 6.738 6.738-6.738 1.027.235-6.738 6.738 6.738 6.738-1.027.235-6.738-6.738-6.738 6.738-1.027-.235 6.738-6.738z\'/%3e%3c/svg%3e") center/1em auto no-repeat',
                border: 'none',
                fontSize: '1rem',
                opacity: 0.5,
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => e.target.style.opacity = '1'}
              onMouseLeave={(e) => e.target.style.opacity = '0.5'}
            ></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Chain Pagename</label>
                  <select
                    name="pageName"
                    className="form-select"
                    value={formData.pageName || formData.pagename || formData.page || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select Page</option>
                    <option value="dashboard">Dashboard</option>
                    <option value="top-header">Top Header</option>
                    <option value="settings">Settings</option>
                  </select>

                  <label className="form-label mt-3">Page Type</label>
                  <select
                    name="pageType"
                    className="form-select"
                    value={formData.pageType || formData.type || ""}
                    onChange={handleChange}
                  >
                    <option value="marquee">Marquee</option>
                    <option value="popup">Popup</option>
                  </select>

                  <label className="form-label mt-3">Marquee Direction</label>
                  <select
                    name="direction"
                    className="form-select"
                    value={formData.direction || ""}
                    onChange={handleChange}
                  >
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select>

                  <label className="form-label mt-3">Validity</label>
                  <input
                    type="date"
                    name="validity"
                    className="form-control"
                    value={formData.validity?.split("T")[0] || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Cookie Time (Hours)</label>
                  <input
                    type="number"
                    name="cookieTime"
                    className="form-control"
                    value={formData.cookieTime || formData.cookie_time || ""}
                    onChange={handleChange}
                    min="1"
                    placeholder="Enter hours"
                  />

                  <label className="form-label mt-3">Page Title</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={formData.title || ""}
                    onChange={handleChange}
                    placeholder="Enter page title"
                  />

                  <label className="form-label mt-3">Notification Message</label>
                  <div style={{ position: "relative" }}>
                    <textarea
                      name="message"
                      className="form-control"
                      rows="4"
                      placeholder="Write your notification message here..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>

                    {/* Special Characters Button */}
                    <div style={{ marginTop: "6px" }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary text-dark"
                        onClick={(e) => {
                          const menu = e.currentTarget.nextSibling;
                          menu.style.display = menu.style.display === "flex" ? "none" : "flex";
                        }}
                      >
                        ➕ Add Special Character
                      </button>

                      {/* Character Grid */}
                      <div
                        style={{
                          display: "none",
                          flexWrap: "wrap",
                          gap: "4px",
                          marginTop: "6px",
                          background: "#f8f9fa",
                          padding: "6px",
                          borderRadius: "6px",
                        }}
                      >
                        {specialChars.map((char) => (
                          <button
                            key={char}
                            type="button"
                            className="btn btn-sm btn-light border"
                            style={{ fontSize: "14px", padding: "2px 6px" }}
                            onClick={() =>
                              insertSpecialCharacter("message", char, setFormData, formData)
                            }
                          >
                            {char}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                  </div>

                </div>
              </div>
            </div>

            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-outline-secondary text-dark"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-dark">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// ======================================================
// ✨ Main Component
// ======================================================
const NotificationSetting = () => {
  const [notifications, setNotifications] = useState([]);
  const [formData, setFormData] = useState({
    pageName: "",
    pageType: "marquee",
    direction: "left",
    title: "",
    message: "",
    cookieTime: 24,
    validity: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState({ message: "", title: "" });
  const [loading, setLoading] = useState(false);

  // Fetch Data
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await listSettings();
      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
      setNotifications(data);
    } catch {
      setError("Failed to fetch notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      // Format data to match API expectations
      const formattedData = {
        pagename: formData.pageName,
        type: formData.pageType,
        marque_dir: formData.direction,
        title: formData.title,
        message: formData.message,
        cookie_time: parseInt(formData.cookieTime),
        validity: formData.validity,
      };

      // Remove any undefined, null, or empty string values
      Object.keys(formattedData).forEach(key => {
        if (formattedData[key] === undefined || formattedData[key] === null || formattedData[key] === "") {
          delete formattedData[key];
        }
      });
      
      // console.log("Adding notification with data:", formattedData); // Debug log
      
      await addSettings(formattedData);
      fetchNotifications();
      setFormData({
        pageName: "",
        pageType: "",
        marque_dir: "",
        title: "",
        message: "",
        cookieTime: 24,
        validity: "",
      });
      setSuccess("Notification added successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      console.error("Add error:", err); // Debug log
      setError("Failed to save notification: " + (err.response?.data?.message || err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (n) => {
    setSelected(n);
    setShowModal(true);
  };

  const handleSaveEdit = async (updatedData) => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      // Clean and format the data before sending to match API expectations
      const cleanedData = {
        pagename: updatedData.pageName || updatedData.pagename || updatedData.page || "",
        type: updatedData.pageType || updatedData.type || "marquee",
        marque_dir: updatedData.direction || "left",
        title: updatedData.title || "",
        message: updatedData.message || updatedData.notification || "",
        cookie_time: parseInt(updatedData.cookieTime || updatedData.cookie_time || 24),
        validity: updatedData.validity ? new Date(updatedData.validity).toISOString().split('T')[0] : "",
      };

      // Remove any undefined, null, or empty string values
      Object.keys(cleanedData).forEach(key => {
        if (cleanedData[key] === undefined || cleanedData[key] === null || cleanedData[key] === "") {
          delete cleanedData[key];
        }
      });

      // console.log("Sending update data:", cleanedData); // Debug log
      
      // Use the correct ID field
      const notificationId = updatedData.id || updatedData._id;
      if (!notificationId) {
        throw new Error("No valid ID found for notification");
      }

      await updateSettings(notificationId, cleanedData);
      fetchNotifications();
      setShowModal(false);
      setSelected(null);
      setSuccess("Notification updated successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      console.error("Update error:", err); // Debug log
      setError("Failed to update notification: " + (err.response?.data?.message || err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  const handleViewMessage = (message, title) => {
    setSelectedMessage({ message: message || "No message content", title });
    setShowMessageModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this notification?")) {
      try {
        setLoading(true);
        setError("");
        setSuccess("");
        await DeleteSettings(id);
        fetchNotifications();
        setSuccess("Notification deleted successfully!");
        setTimeout(() => setSuccess(""), 3000);
      } catch (err) {
        setError("Failed to delete notification: " + (err.message || "Unknown error"));
      } finally {
        setLoading(false);
      }
    }
  };

  const truncateText = (text, limit = 50) => {
    if (!text || text.length <= limit) return text;
    return text.substring(0, limit) + "...";
  };

  return (
     <div className="wrapper">
      <AdminLeftMenu />
      <div className="main">
        <AdminHeader />
        <main className="container-fluid py-4" style={{ minHeight: "calc(100vh - 140px)", overflow: "hidden" }}>
          <h1 className="fw-bold mb-4">Notification Settings</h1>

          {/* ===== FORM SECTION ===== */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h5 className="fw-semibold border-bottom pb-2 mb-3">
                Enter Notification
              </h5>

              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}

              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="form-label">Chain Pagename</label>
                    <select
                      name="pageName"
                      className="form-select"
                      value={formData.pageName}
                      onChange={handleChange}
                    >
                      <option value="">Please Select</option>
                      <option value="dashboard">Dashboard</option>
                      <option value="top-header">Top Header</option>
                      <option value="settings">Settings</option>
                    </select>

                    <label className="form-label mt-3">Page Type</label>
                    <select
                      name="pageType"
                      className="form-select"
                      value={formData.pageType}
                      onChange={handleChange}
                    >
                      <option value="marquee">Marquee</option>
                      <option value="popup">Popup</option>
                    </select>

                    <label className="form-label mt-3">Marquee Direction</label>
                    <select
                      name="direction"
                      className="form-select"
                      value={formData.direction}
                      onChange={handleChange}
                    >
                      <option value="left">Left</option>
                      <option value="right">Right</option>
                    </select>

                    <label className="form-label mt-3">
                      Validity (must be greater than today)
                    </label>
                    <input
                      type="date"
                      name="validity"
                      className="form-control"
                      value={formData.validity}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">
                      Cookie Time (Hours to show popup)
                    </label>
                    <input
                      type="number"
                      name="cookieTime"
                      className="form-control"
                      value={formData.cookieTime}
                      onChange={handleChange}
                    />

                    <label className="form-label mt-3">Page Title</label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      placeholder="Title for identification"
                      value={formData.title}
                      onChange={handleChange}
                    />



                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-dark mt-3"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save Notification"}
                </button>
              </form>
            </div>
          </div>

          {/* ===== LIST SECTION ===== */}
          <div className="card border-0 shadow-sm" style={{ height: "calc(100vh - 480px)", minHeight: "400px" }}>
            <div className="card-header bg-white border-bottom">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="fw-semibold mb-0">Notification List</h5>
                <small className="text-muted">
                  Total: {notifications.length}
                </small>
              </div>
            </div>

            {loading ? (
              <div className="text-center py-3 text-muted">
                Loading notifications...
              </div>
            ) : (
              // ✅ Fixed container that only scrolls internally
              <div
                className="card-body p-0"
                style={{
                  height: "100%",
                  overflow: "hidden",
                  position: "relative"
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    overflowX: "auto",
                    overflowY: "auto",
                    display: "block"
                  }}
                >
                  <table
                    className="table table-bordered align-middle mb-0"
                    style={{
                      minWidth: "1200px",
                      width: "max-content",
                      tableLayout: "fixed"
                    }}
                  >
                    <thead className="table-light" style={{ position: "sticky", top: "0", zIndex: "10", color: "#ffffffff" }}>
                      <tr>
                        <th style={{ minWidth: "60px", width: "60px" }}>S.No.</th>
                        <th style={{ minWidth: "150px", width: "150px" }}>Title</th>
                        <th style={{ minWidth: "300px", width: "300px" }}>Message</th>
                        <th style={{ minWidth: "120px", width: "120px" }}>Added On</th>
                        <th style={{ minWidth: "120px", width: "120px" }}>Validity</th>
                        <th style={{ minWidth: "100px", width: "100px" }}>Page</th>
                        <th style={{ minWidth: "80px", width: "80px" }}>Type</th>
                        <th style={{ minWidth: "80px", width: "80px" }}>Status</th>
                        <th style={{ minWidth: "120px", width: "120px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notifications.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No notifications found.
                          </td>
                        </tr>
                      ) : (
                        notifications.map((n, i) => (
                          <tr key={n.id || i}>
                            <td className="text-center" style={{ width: "60px" }}>
                              {i + 1}
                            </td>
                            <td className="fw-medium" style={{ width: "150px" }}>
                              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {n.title}
                              </div>
                            </td>
                            <td style={{ width: "300px" }}>
                              <div style={{
                                maxWidth: "280px",
                                wordWrap: "break-word",
                                whiteSpace: "normal",
                                overflow: "hidden"
                              }}>
                                {truncateText(n.message || n.notification || "", 50)}
                                {(n.message || n.notification) &&
                                  (n.message || n.notification).length > 50 && (
                                    <>
                                      <br />
                                      <button
                                        className="btn btn-link btn-sm p-0 text-primary text-decoration-underline"
                                        onClick={() =>
                                          handleViewMessage(
                                            n.message || n.notification,
                                            n.title
                                          )
                                        }
                                      >
                                        View More
                                      </button>
                                    </>
                                  )}
                              </div>
                            </td>
                            <td className="text-muted small" style={{ width: "120px" }}>
                              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {n.created_at || n.addedOn || "-"}
                              </div>
                            </td>
                            <td className="text-muted small" style={{ width: "120px" }}>
                              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {n.validity || "-"}
                              </div>
                            </td>
                            <td style={{ width: "100px" }}>
                              <span className="badge bg-light text-dark border">
                                {n.pagename || n.pageName || n.page || "-"}
                              </span>
                            </td>
                            <td style={{ width: "80px" }}>
                              <span
                                className={`badge ${(n.type || n.pageType) === "popup"
                                  ? "bg-info"
                                  : "bg-warning"
                                  }`}
                              >
                                {n.type || n.pageType || "-"}
                              </span>
                            </td>
                            <td style={{ width: "80px" }}>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td style={{ width: "120px" }}>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => handleEdit(n)}
                                  title="Edit notification"
                                >
                                  ✏️
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDelete(n.id || n._id)}
                                  title="Delete notification"
                                >
                                  🗑️
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

        </main>
        <AdminFooter style={{ marginTop: "auto" }} />
      </div>

      {showModal && (
        <EditNotificationModal
          show={showModal}
          onClose={() => setShowModal(false)}
          notification={selected}
          onSave={handleSaveEdit}
        />
      )}

      {showMessageModal && (
        <ViewMessageModal
          show={showMessageModal}
          onClose={() => setShowMessageModal(false)}
          message={selectedMessage.message}
          title={selectedMessage.title}
        />
      )}
    </div>
  );
};

export default NotificationSetting;
